import React from 'react';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import {
    CustomBreadcrumbs,
    CustomList,
    CustomSelectInput,
} from 'candy-commons-components';
import {
    DateField,
    Filter,
    FunctionField,
    TextField,
    useTranslate,
} from 'react-admin';
import CustomDatagrid from '../../components/organisms/customDatagrid';
import BRANDS from '../../data/ecommerceBrandChoices.json';
import { countryChoices, formatCollectionId } from './form';

const SpecialInitiativesFilter = (props) => (
    <Filter {...props}>
        <CustomSelectInput source="brand" choices={BRANDS} alwaysOn />
        <CustomSelectInput
            source="country"
            choices={countryChoices}
            translateChoice={false}
            alwaysOn
        />
    </Filter>
);

const SpecialInitiativesList = (props) => {
    const translate = useTranslate();
    return (
        <>
            <CustomBreadcrumbs
                data={[
                    {
                        text: translate(
                            'resources.ecommerce-special-initiatives.name'
                        ),
                        url: '',
                        icon: <LocalOfferIcon />,
                    },
                ]}
            />
            <CustomList
                {...props}
                filters={<SpecialInitiativesFilter />}
                sort={{ field: 'updatedAt', order: 'DESC' }}
                perPage={25}
                exporter={false}
                bulkActionButtons={false}
            >
                <CustomDatagrid rowClick="edit" choiceColumns>
                    <TextField source="brand" />
                    <FunctionField
                        source="countries"
                        sortable={false}
                        render={(record) =>
                            record.countries.includes('ALL')
                                ? translate(
                                      'resources.ecommerce-special-initiatives.allCountries'
                                  )
                                : record.countries.join(', ')
                        }
                    />
                    <FunctionField
                        source="collectionId"
                        render={(record) =>
                            formatCollectionId(record.collectionId)
                        }
                    />
                    <DateField
                        source="validFrom"
                        options={{ timeZone: 'UTC' }}
                    />
                    <DateField source="validTo" options={{ timeZone: 'UTC' }} />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};

export default SpecialInitiativesList;
